<template>
  <div class="px-12 py-40 text-slider">
    <h6 class="text-black block text-center w-full text-slider-title">{{ title }}</h6>
    <div class="md:py-24 mt-24 md:pt-0">
      <ul class="sm:flex flex-nowrap w-full justify-center gap-8 md:gap-20 mb-14 words-1 hidden">
        <li v-for="(word, idx) in [...words1, ...words1]" :key="idx">
          <span class="h4">
            {{ word }}
          </span>
        </li>
      </ul>
      <ul v-if="words2" class="sm:flex flex-nowrap w-full justify-center gap-8 md:gap-20 mb-14 words-2 hidden">
        <li v-for="(word, idx) in [...words2, ...words2]" :key="idx">
          <span class="h4">
            {{ word }}
          </span>
        </li>
      </ul>
      <ul v-if="words3" class="sm:flex flex-nowrap w-full justify-center gap-8 md:gap-20 mb-14 words-3 hidden">
        <li v-for="(word, idx) in [...words3, ...words3]" :key="idx">
          <span class="h4">
            {{ word }}
          </span>
        </li>
      </ul>

      <ul class="flex flex-col sm:hidden flex-wrap gap-4">
        <li v-for="(word, idx) in [...new Set([...words1, ...words2, ...words3])]" :key="idx">
          <span class="h4">
            {{ word }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


defineProps({
  title: { type: String, required: true },
  words1: { type: Array as PropType<Array<string>>, required: true },
  words2: { type: Array as PropType<Array<string>>, required: false, default: () => null },
  words3: { type: Array as PropType<Array<string>>, required: false, default: () => null },
});

onMounted(() => {
  const uncover = gsap.timeline({ paused: true });

  gsap.from('.text-slider .words-1', { xPercent: -25 });
  gsap.from('.text-slider .words-2', { xPercent: 0 });
  gsap.from('.text-slider .words-3', { xPercent: -25 });

  uncover.to('.text-slider .words-1', { xPercent: 20, ease: 'sine.in' });
  uncover.to('.text-slider .words-2', { xPercent: -20, ease: 'sine.in'}, "<");
  uncover.to('.text-slider .words-3', { xPercent: 20, ease: 'sine.in' }, "<");

  ScrollTrigger.create({
    trigger: '.text-slider-title',
    start: 'max',
    end: '+=75%',
    animation: uncover,
    scrub: 1,
  });

  ScrollTrigger.refresh();
});

</script>
<style lang="scss" scoped>
ul:first-child {
  li {
    &:nth-child(even) {
      font-family: 'FiraGO Bold Italic';
    }
  }
}

ul:nth-child(2) {

  li {
    &:nth-child(odd) {
      font-family: 'FiraGO Bold Italic';
    }
  }
}

ul:last-child {
  li {
    &:nth-child(even) {
      font-family: 'FiraGO Bold Italic';
    }
  }
}


@media (screen(md)) {
  li {
    span {
      white-space: nowrap;
    }
  }
}
</style>